import React from "react";
import ExploreOne from "../components/Section/ExploreDivisionOne"
import ExploreTwo from "../components/Section/ExploreDivisionTwo"

function Automation() {
 

  return (
    <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">
    
        <ExploreOne />
        <ExploreTwo />
      
    </div>
  );
}

export default Automation;
